import {
  putVerifyOTPEmail,
  putVerifyOTPSms,
  VerifyOTPRequest,
  VerifyOTPResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { OtpVia } from '../../components/login/EnterOTP';
import { ResponseMessage } from '../../constants';
import { Self } from '../common';

function* putVerifyOTPRequest(
  self: Self,
  body: VerifyOTPRequest,
  otpMode: OtpVia
): Generator<Promise<FlowReturn<VerifyOTPResponse>>> {
  self.isLoading = true;
  try {
    const response = yield otpMode === OtpVia.EMAIL
      ? putVerifyOTPEmail(body)
      : putVerifyOTPSms(body);
    const { status, data } = (response as VerifyOTPResponse).data;
    if (otpMode === OtpVia.SMS)
      self.otp = { ...self.otp, authToken: data.authToken };
    if (status.code === 1000) {
      return Promise.resolve(data.otpToken);
    }
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default putVerifyOTPRequest;
